import { getGuidsToSkip } from '@thoughtspot/session-service';
import { useEffect, useRef, useState } from 'react';
import { useGetUsersListPrincipalQuery } from "../../../../../services/user-group/user-group-service";
import { getSelectedOnCurrentPage, onRowsSelectAction, refreshCells, updateRowData, } from '../../../../user-management/util';
import { getDefaultUserListParams, SORT_KEY_MAP, TableColumnId, } from '../constants';
const parseUsersData = (objects) => objects.map((user) => ({
    id: user.id,
    name: user.name || '',
    displayName: user.displayName || '',
    type: user.type || '',
    orgIds: user.orgIds || [],
    created: user.created,
    userState: user.statistics?.userState || '',
    isChecked: false,
}));
export const useUsersList = ({ isClusterAdmin, orgNameMap, orgsListLoading, }) => {
    const gridRef = useRef(null);
    const [rowData, setRowData] = useState([]);
    const [gridLoading, setGridLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRowsIds, setSelectedRowsIds] = useState([]);
    const [lastOperatedPage, setLastOperatedPage] = useState(0);
    const [userListInput, setUserListInput] = useState(getDefaultUserListParams(isClusterAdmin));
    const { data: usersList, loading: usersListLoading, refetch: refreshUsersList, } = useGetUsersListPrincipalQuery({ ...userListInput });
    const selectedRowsIdsRef = useRef(selectedRowsIds);
    selectedRowsIdsRef.current = selectedRowsIds;
    const orgsReady = !isClusterAdmin || !orgsListLoading;
    useEffect(() => {
        if (usersList && !usersListLoading && orgsReady) {
            const parsed = parseUsersData(usersList.objects || []);
            const checked = getSelectedOnCurrentPage(selectedRowsIdsRef.current, parsed);
            updateRowData(parsed, checked, setRowData);
            setGridLoading(false);
            setIsLoading(false);
        }
    }, [usersList, usersListLoading, orgsReady]);
    useEffect(() => {
        const filtered = getSelectedOnCurrentPage(selectedRowsIds, rowData);
        if (gridRef.current) {
            updateRowData(rowData, filtered, setRowData);
            refreshCells(gridRef, filtered, TableColumnId.ACTIONS);
        }
    }, [selectedRowsIds]);
    useEffect(() => {
        if (isClusterAdmin && gridRef.current && !orgsListLoading) {
            refreshCells(gridRef, [], TableColumnId.GROUPS_OR_ORGS);
        }
    }, [orgNameMap]);
    const onChangeOffset = (offset) => {
        setUserListInput(prev => ({
            ...prev,
            offset,
            skipIds: getGuidsToSkip(),
        }));
        setIsLoading(true);
    };
    const onSearchChange = (term) => {
        setUserListInput(prev => ({
            ...prev,
            offset: 0,
            pattern: term,
            skipIds: getGuidsToSkip(),
        }));
        setIsLoading(true);
    };
    const onSortingChanged = (sortState) => {
        const col = sortState.find((el) => el.sort !== 'null') || sortState[0];
        const sort = col && SORT_KEY_MAP[col.colId];
        const sortAscending = col ? col.sort === 'asc' : true;
        setUserListInput(prev => ({
            ...prev,
            sort,
            offset: 0,
            sortAscending,
            skipIds: getGuidsToSkip(),
        }));
        setIsLoading(true);
    };
    const onRowsSelected = (rowIds) => {
        onRowsSelectAction(rowIds, rowData, userListInput, lastOperatedPage, setLastOperatedPage, selectedRowsIds, setSelectedRowsIds);
    };
    const onGridReady = (api) => {
        gridRef.current = api;
    };
    const isLastBatch = gridLoading || (usersList?.isLastBatch ?? true);
    return {
        rowData,
        gridLoading,
        isLoading,
        setIsLoading,
        selectedRowsIds,
        setSelectedRowsIds,
        userListInput,
        isLastBatch,
        refreshUsersList,
        onChangeOffset,
        onSearchChange,
        onSortingChanged,
        onRowsSelected,
        onGridReady,
    };
};
//# sourceMappingURL=useUsersList.js.map